

































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator'
import SavePermission from '../components/permission/SavePermission.vue'
import PermissionAccount from '../components/permission/PermissionAccount.vue'
import PermissionRole from '../components/permission/PermissionRole.vue'
import PermissionDetail from '../components/permission/PermissionDetail.vue'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import { Permission } from '@/model/permission/permission'
import { Pagination, Divider, Popconfirm, Form, message } from 'ant-design-vue'
import {
  batchAdd,
  PagePermissionAccountParam,
  removePermissionAccount,
  removePermissionAccounts,
  PagePermissionParam,
  deletePermission
} from '@/api/permission/permission'
import { NewPage } from '@/model/common/newPage'

const PermissionStore = namespace('app-addressbook/permission')
interface Paging {
  pageSize?: number
  current?: number
  total?: number
}
@Component({
  components: {
    SavePermission,
    PermissionAccount,
    PermissionRole,
    'a-popconfirm': Popconfirm,
    PermissionDetail
  }
})
export default class YkdPermission extends Vue {
  @PermissionStore.Mutation('setPermission') setPermission!: Function
  @PermissionStore.Mutation('setSelectedPermission')
  setSelectedPermission!: Function

  @PermissionStore.Action('getPermissions') getPermissions!: Function
  @PermissionStore.State('permissions') permissions!: NewPage<Permission>
  @PermissionStore.State('selectedPermission') selectedPermission!: Permission

  private rightTableTitel = ''
  private saveDraw = false
  private clickIndex: number = 0
  private tableLoading: boolean = false
  private keyword: string = ''
  private permissionDetailVisible: boolean = false

  private pagination: Paging = {
    pageSize: 10,
    current: 1,
    total: 0
  }

  addPermission() {
    this.rightTableTitel = '添加权限'
    this.setPermission({})
    this.saveDraw = true
  }

  private columns: any = [
    {
      title: '权限标题',
      dataIndex: 'title',
      key: 'num'
    },
    {
      title: '权限名称',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: '创建时间',
      key: 'gmtCreated',
      dataIndex: 'gmtCreated'
    },
    {
      title: '备注',
      key: 'remark',
      dataIndex: 'remark'
    },
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' }
    }
  ]

  inputChange() {}

  rightDrawClose() {
    this.saveDraw = false
  }

  // permissionSelected(index: number) {
  //   this.clickIndex = index
  //   this.setSelectedPermission(this.permissions[index])
  //   this.$router.push({ query: { permissionId: this.permissions[index].id } })
  // }

  async mounted() {
    await this.queryPermissions()
  }

  async queryPermissions() {
    this.tableLoading = true

    const pageParam: PagePermissionParam = {
      keyword: this.keyword,
      pagination: this.pagination.current! - 1,
      pageSize: this.pagination.pageSize
    }

    await this.getPermissions(pageParam)
    this.pagination.total = this.permissions.totalCount
    this.tableLoading = false
  }

  handleTableChange(pagination: Paging) {
    this.pagination = pagination
    this.queryPermissions()
  }

  permissionEdit(record: Permission) {
    this.rightTableTitel = '编辑权限'
    this.setSelectedPermission(record)
    this.setPermission(record)
    this.saveDraw = true
  }

  async deletePermission(record: Permission) {
    const result = await deletePermission(record.id!)

    if (result === '5050') {
      message.warn('无法删除和成员已经绑定的权限')
    } else if (result === '5060') {
      message.warn('无法删除和角色已经绑定的权限')
    } else if (result === '2000') {
      this.refreshPermission(1)
      message.success('删除权限成功')
    } else {
      message.error('删除失败')
    }
  }

  // async refresh() {
  //   this.pagination = {
  //     pageSize: 10,
  //     current: 1,
  //     total: 0
  //   }
  //   await this.queryPermissions()
  // }

  async refreshPermission(num: number) {
    if (num > 1) {
      this.pagination = {
        pageSize: 10,
        current: 1,
        total: 0
      }
      await this.queryPermissions()
      return
    }
    if (
      this.permissions.data &&
      this.permissions.data.length == 1 &&
      this.permissions.pagination != 0
    ) {
      this.pagination = {
        current: this.pagination.current! - 1,
        pageSize: this.pagination.pageSize,
        total: 0
      }
    }
    await this.queryPermissions()
  }

  detailClose() {
    this.permissionDetailVisible = false
  }

  permissionView(record: any) {
    this.setSelectedPermission(record)
    this.permissionDetailVisible = true
  }
}
